export const APP_NAME = "PattaAdda";

